// extracted by mini-css-extract-plugin
export default {"list":"SpacedList_list__DiBa6","item":"SpacedList_item__dv3ZS"};